import Link from '@mui/material/Link';
import './Copyright.css';

const Copyright = () => {
  return (
    <div className="copyright-root">
      &copy;&nbsp;
      <Link color="inherit" href="https://itrack.hu/" data-qa-element-id="owner-company-link">
        iData Kft.
      </Link>
      &nbsp;{new Date().getFullYear()}
    </div>
  );
};

export default Copyright;
